export interface ViewModel {
  email: string;
  captchaValue: string | null;
}

export const viewModelNewValues: ViewModel = {
  email: "",
  captchaValue: null
};
